import React, { FC, useCallback } from "react"
import { Map } from "immutable"

import { TaskName } from "../FormFields"
import { LabelerPayment } from "./LabelerPayment"

interface LabelerPaymentsProps {
    taskNames: string[]
    value: Map<string, number | undefined>
    onChange: (value: {
        labelerPayments: Map<string, number | undefined>
    }) => void
}

export const LabelerPayments: FC<LabelerPaymentsProps> = ({
    taskNames,
    value,
    onChange
}) => {
    const renderTask = useCallback(
        (taskName: string, index: number, arr: TaskName[]) => {
            const entry = value.get(taskName)
            const handleChange = (v: number | undefined) =>
                onChange({
                    labelerPayments: value.set(taskName, v)
                })

            return (
                <LabelerPayment
                    key={taskName}
                    label={
                        arr.length === 1
                            ? "Tasks pay $"
                            : `Task ${taskName} pays $`
                    }
                    className={index === arr.length - 1 ? "" : "mb-2"}
                    value={entry}
                    onChange={handleChange}
                ></LabelerPayment>
            )
        },
        [value, onChange]
    )

    return (
        <div>
            {taskNames.length === 0
                ? "There is no task defined"
                : taskNames.map(renderTask)}
        </div>
    )
}
